<section
  class="landing-a__section landing-a__our-product-section"
  id="our-product"
  appLandingReveal="landing-a__our-product-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__our-product-grid">
      <div class="landing-a__our-product-pillars landing-a__case-showcase-cards">
        @for (pillar of pillars; track pillar.key) {
          <article class="landing-a__our-product-pillar landing-a__case-showcase-card">
            <div class="landing-a__case-showcase-card-icon" aria-hidden="true">
              <i-tabler [name]="pillar.icon"></i-tabler>
            </div>
            <div class="landing-a__case-showcase-card-body">
              <h3>{{ 'landing.landing_1.our_product.pillars.' + pillar.key + '.title' | translate }}</h3>
              <p>{{ 'landing.landing_1.our_product.pillars.' + pillar.key + '.description' | translate }}</p>
            </div>
          </article>
        }
      </div>

      <div class="landing-a__our-product-copy">
        <span class="landing-a__section-kicker">
          {{ 'landing.landing_1.our_product.kicker' | translate }}
        </span>
        <h2 class="landing-a__our-product-title">
          {{ 'landing.landing_1.our_product.title' | translate }}
        </h2>
        <p class="landing-a__our-product-subtitle">
          {{ 'landing.landing_1.our_product.subtitle' | translate }}
        </p>

        <blockquote class="landing-a__our-product-mission">
          <span class="landing-a__our-product-mission-label">
            {{ 'landing.landing_1.our_product.mission_label' | translate }}
          </span>
          <p>{{ 'landing.landing_1.our_product.mission' | translate }}</p>
        </blockquote>
      </div>
    </div>
  </div>
</section>
